import { render, staticRenderFns } from "./fleet-column-destination.vue?vue&type=template&id=355b79f0&scoped=true&"
import script from "./fleet-column-destination.vue?vue&type=script&lang=js&"
export * from "./fleet-column-destination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355b79f0",
  null
  
)

export default component.exports